'use client'

import { useEffect, useState } from 'react'

/* =========================================
   LIVE SF CLOCK
   Shared by the footer and the announce bar. Returns '' until the
   first client tick so server HTML never carries a stale time.
   ========================================= */
export function useClock() {
  const [time, setTime] = useState('')

  useEffect(() => {
    const update = () => {
      setTime(
        new Date().toLocaleTimeString('en-US', {
          timeZone: 'America/Los_Angeles',
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
      )
    }
    update()
    const id = setInterval(update, 1000)
    return () => clearInterval(id)
  }, [])

  return time
}
